import './Menu.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var content = '_1m01arl3-3-5-0';
export var group = '_1m01arl4-3-5-0';
export var item = _7a468({defaultClassName:'_1m01arl5-3-5-0',variantClassNames:{disabled:{true:'_1m01arl6-3-5-0',false:'_1m01arl7-3-5-0'}},defaultVariants:{disabled:false},compoundVariants:[]});
export var itemChildren = '_1m01arl8-3-5-0';
export var label = '_1m01arl2-3-5-0';
export var subChildren = '_1m01arl9-3-5-0';
export var tooltip = '_1m01arl0-3-5-0';
export var tooltipWrapper = '_1m01arl1-3-5-0';